import config from 'config'

export const root = `${config.publicPath}/adventurous-journeys`
export const rootMyEvents = `${config.publicPath}/adventurous-journeys/my-events`
export const rootAllEvents = `${config.publicPath}/adventurous-journeys/all-events`

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Journey Category',
    intlKey: 'table.journey_category',
    sortableId: 'ajEventCategory.value'
  },
  {
    id: 3,
    label: 'Journey Activity',
    intlKey: 'table.journey_activity',
    sortableId: 'activityCategory.id'
  },
  {
    id: 4,
    label: 'Journey Type',
    intlKey: 'table.journey_type',
    sortableId: 'activityCategory.parent.id'
  },
  {
    id: 5,
    label: 'Suitable for Award Level',
    intlKey: 'table.suitable_for_award_level'
  },
  {
    id: 6,
    label: 'Location',
    intlKey: 'table.location',
    sortableId: 'location'
  },
  {
    id: 7,
    label: 'Created by',
    intlKey: 'table.created_by'
  }
]

export const tableHeadersSimple = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'Journey Category',
    intlKey: 'table.journey_category'
  },
  {
    id: 3,
    label: 'Journey Activity',
    intlKey: 'table.journey_activity'
  },
  {
    id: 4,
    label: 'Location',
    intlKey: 'table.location'
  }
]


export const participantsTableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Preparation',
    intlKey: 'table.preparation'
  },
  {
    id: 5,
    label: 'Practice',
    intlKey: 'table.practice'
  },
  {
    id: 6,
    label: 'Qualifying',
    intlKey: 'table.qualifying'
  },
  {
    id: 7,
    label: 'Report',
    intlKey: 'table.report'
  },
  {
    id: 8,
    label: 'Assesor approve',
    intlKey: 'table.assessor_approve'
  },
  {
    id: 9,
    label: 'Progress',
    intlKey: 'table.progress'
  }
]

